module.exports = {
  recommends: 'Reverb Recommends',
  topPick: 'Top Pick',
  reverbNews: 'Reverb News',
  treatYourself: 'Treat Yourself',
  seeSimilar: 'See Similar {{category}}',
  seeMore: 'See More',
  addToCart: 'Add to Cart',
};



// WEBPACK FOOTER //
// ./javascripts/translations/product_show_page/en.js